// Companion to ADVISOR_IMPERSONATE_CLIENT_ID_KEY (@savvy/deprecated-shared/utils/advisor-utils):
// the household the impersonated client was reached through, for multi-household
// clients where the client's own ClientProfile household can differ from the
// household actually being worked on. Always set/cleared alongside the client id --
// never read without it.
export const ADVISOR_IMPERSONATE_HOUSEHOLD_ID_KEY = 'impersonateHouseholdId';

export function setImpersonateHouseholdId(householdId?: string) {
  if (householdId) {
    sessionStorage.setItem(ADVISOR_IMPERSONATE_HOUSEHOLD_ID_KEY, householdId);
  } else {
    sessionStorage.removeItem(ADVISOR_IMPERSONATE_HOUSEHOLD_ID_KEY);
  }
}

export function getImpersonateHouseholdId() {
  return sessionStorage.getItem(ADVISOR_IMPERSONATE_HOUSEHOLD_ID_KEY);
}
